module.exports = __webpack_public_path__ + "static/Gotham-Light-d7095df8191e82929b3177e7adb1e6cd.woff2";